import { MagnifyingGlassIcon, XCircleIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import type { KeyboardEvent} from "react";
import { useCallback } from "react";
import { forwardRef } from "react";

import type { FormInputBaseVariants } from "~/components/formElements/formInputBaseVariant.ts";
import { formInputBaseVariants } from "~/components/formElements/formInputBaseVariant.ts";

type SearchInputProps = FormInputBaseVariants & {
	autoFocus?: boolean;
	clearable?: boolean;
	value: string;
	onChange: (value: string) => void;
	onKeydown?: (event: KeyboardEvent<HTMLInputElement>) => void;
	placeholder?: string;
}

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
	{
		autoFocus, inputSize, onChange, onKeydown = () => {
	}, placeholder, theme, value,clearable = true
	},
	ref,
) {
	const handleClearClick = useCallback(() => {
		onChange("");
	}, [onChange]);

	return (
		<div className="relative focus-within:z-10">
			<div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
				<MagnifyingGlassIcon className="size-5 text-gray-400"
									 aria-hidden="true" />
			</div>

			<input
				ref={ref}
				type="text"
				name="searchInput"
				autoFocus={autoFocus}
				className={clsx(formInputBaseVariants({ inputSize, theme }), "pl-10")}
				placeholder={undefined === placeholder ? "Suche ..." : placeholder}
				value={value}
				autoComplete={"off"}
				onKeyDown={onKeydown}
				onChange={(e) => {
					onChange(e.target.value);
				}}
			/>
			{clearable && value && (
				<div className="absolute right-0 top-0 h-full">
					<button onClick={handleClearClick} className="flex h-full items-center pr-2">
						<XCircleIcon className="size-5 fill-gray-300" />
					</button>
				</div>
			)}
		</div>
	);
});
export default SearchInput;
